<template>
  <div class="admin-times-container">
    <div class="admin-times-heading text-center collapsed" :class="milage_reimbursements.length ? 'clickable' : ''" data-toggle="collapse" data-target="#milage-reimbursements-body">
      <h5 v-if="hasMilageReimbursements()" class="mb-0 text-black-50"><i class="fa"></i> {{transEdit('milage-reimbursements-for-month')}} ({{milage_reimbursements.length}} st, {{transEdit('sum').toLowerCase()}}: {{
          numberFormat(milage_reimbursements_sum)}} kr)
      </h5>
      <h5 class="mb-0 text-black-50" v-else>{{transEdit('no-milage-reimbursements-month')}}</h5>
    </div>
    <div class="milage-reimbursements-body collapse" id="milage-reimbursements-body">
      <div v-for="milage_reimbursement in milage_reimbursements" class="d-flex flex-fill justify-content-between border-top pt-2 pb-2 flex-column flex-md-row">
        <div class="">{{milage_reimbursement.date}}</div>
        <div class="text-md-right pr-md-4">{{numberFormat(milage_reimbursement.kilometers)}} km - {{numberFormat(milage_reimbursement.reimbursement)}} kr/km</div>
        <div>
          <button class="btn btn-outline-primary btn-sm" @click="showDeleteMilageReimbursementModal(milage_reimbursement)"><i class="fa fa-search"></i> {{transEdit('show')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "therapist-dash-milage-reimbursement-list",
  props: ['date', 'route_milage_reimbursements', 'do_refresh', 'locked'],
  data: function () {
    return {
      milage_reimbursements: [],
      milage_reimbursements_sum: 0,
    }
  },
  watch: {
    date: function (newDate, oldDate) {
      this.fetchNewAdminTimes(newDate);
    },
  },
  methods: {
    refresh() {
      this.fetchNewAdminTimes(this.date);
    },
    canDeleteExpenditure: function (date) {
      let tempDate = new Date();
      tempDate = new Date(tempDate.getFullYear(), tempDate.getMonth(), 1);
      let inputDate = new Date(date);

      return true;
    },
    showDeleteMilageReimbursementModal: function (milage_reimbursement) {
      let info = {};
      info.showButton = !this.locked;
      info.date = milage_reimbursement.date;
      info.registeredDate = moment(milage_reimbursement.created_at).format('YYYY-MM-DD HH:mm');
      info.kilometers = this.numberFormat(milage_reimbursement.kilometers);
      info.reimbursement = this.numberFormat(milage_reimbursement.reimbursement);
      info.id = milage_reimbursement.id;
      info.sum = this.numberFormat(milage_reimbursement.kilometers * milage_reimbursement.reimbursement);

      this.$eventHub.$emit('therapist-delete-milage-reimbursement', info)
    },
    numberFormat: function (number) {
      return window.number_format(number);
    },
    hasMilageReimbursements: function () {
      return this.milage_reimbursements.length > 0;
    },
    fetchNewAdminTimes: function (date) {
      date = date.getYMD();
      let self = this;

      axios.get(this.$portalUrl(this.route_milage_reimbursements), {
        params: {
          date: date,
        }
      })
          .then(function (response) {
            let tempSum = 0;
            response.data.forEach(function (milage_reimbursement) {
              tempSum += milage_reimbursement.kilometers * milage_reimbursement.reimbursement;
            });

            self.milage_reimbursements_sum = tempSum;
            self.milage_reimbursements = response.data;
          })
          .catch(function (error) {
          });
    },
  },
  mounted () {
    this.refresh();
  }
}
</script>

<style scoped>

</style>
